// removed by extract-text-webpack-plugin
module.exports = {"root":"ModalSwimmy__root__kG2t7","container":"ModalSwimmy__container__2svpi","header":"ModalSwimmy__header___3638","closeButton":"ModalSwimmy__closeButton__1jVG4","icon":"ModalSwimmy__icon__3twDM","heading":"ModalSwimmy__heading__3t_LJ","content":"ModalSwimmy__content__2BTKv","footer":"ModalSwimmy__footer__2R2N3"};


//////////////////
// WEBPACK FOOTER
// ./src/components/ModalSwimmy/ModalSwimmy.css
// module id = 2034
// module chunks = 0